import util from './util';

module.exports = {
    open$Naves: [],
    openHref: [],
    show$Tags: [],
    show$Frames: [],
    checks: [],
    checkIndex: -1,
    maxWidth: 120,
    init(data, name, href) {
        let _this = this;
        _this.$mainLeft = $(".main-left");
        _this.$mainTags = $(".main-tags");
        _this.$mainContents = $('.main-contents');
        _this.$mainTagsBox = $('.main-tags-box');
        _this._addEvent();

        _this.renderNav(data);
        let hash = location.hash.substring(1);
        if (name && href) {
            _this.open(name, href, true);
        }
        if (hash) {
            let $target = _this.$mainLeft.find('[data-href="' + hash + '"]').eq(0);

            if ($target.length) {
                _this.open($target.html(), hash);
            }
        }
    },

    renderNav(menuData) {
        let html = ``;
        menuData.forEach((item, i) => {
            html+=`<li class="fold">`
            html += `
                    <span class="fold-active" data-id="${item.id}">
                        <i class="fa fa-fw fa-${item.icon || 'bars'}"></i>
                        ${item.name}
                        <i class="fa fa-angle-right fr"></i>
                    </span>`;
            if (item.subMenuList) {
                html += `<ul>`
                item.subMenuList.forEach((value) => {
                    html += `<li data-id="${value.id}" data-href="${value.page}">${value.name}</li>`
                })
                html += `</ul>`
            }
            html+=`</li>`
        });
        this.$mainLeft.html(html);
    },


    _addEvent() {
        let _this = this;
                _this.$mainLeft.on('click', (e) => {
            let $t = $(e.target);
            let href = $t.data('href');
            if (href) {
                _this.open($t.html(), href);
                return;
            }
                        let $closest = $t.closest('.fold-active');
            if ($closest.length) {
                let $li = $closest.parent();
                if ($li.hasClass('fold')) {
                    $li.removeClass('fold');
                    $closest.children('.fr').attr('class', 'fa fa-angle-down fr')
                } else {
                    $li.addClass('fold');
                    $closest.children('.fr').attr('class', 'fa fa-angle-right fr')
                }
            }

        });
                _this.$mainTags.on('click', (e) => {
            let $t = $(e.target);
            if ($t.data('type') === 'close') {
                _this._close($t.parent().index())
                return;
            }
            if ($t.prop('tagName') === 'LI') {
                _this._check($t.index());
            }
        });
    },

    open(name, href, notClose, refWindow) {
        let _this = this;

                if (_this.maxWidth > _this.$mainTagsBox.width() - _this.$mainTags.width()) {
            util.info('提示', '您打开太多页面了，请关闭一些页面在打开吧！');
            return;
        }
        let oldIndex = _this._getIndex(href);
        if (oldIndex === -1) {
            //第一次打开
            _this._open(name, href, notClose, refWindow);
        } else {
            //打开过
            _this._check(oldIndex);
        }
    },
        _getIndex(href) {
        let checks = this.checks;
        for (let i = 0, len = checks.length; i < len; i++) {
            if (href === checks[i].href) {
                return i;
            }
        }
        return -1;
    },
        _check(index) {
        let _this = this;
        let checkItem;
        if (_this.checkIndex !== -1) {
            // 修改上一个显示的页面
            checkItem = _this.checks[_this.checkIndex];
            checkItem.$tag.removeClass('check');
            // checkItem.$frame.hide();
            checkItem.$frame.css('z-index', -1);
        }
        checkItem = _this.checks[index];
        checkItem.$tag.addClass('check');
        // checkItem.$frame.show();
        checkItem.$frame.css('z-index', 0);
        _this.checkIndex = index;
        location.hash = checkItem.href;
    },

    _open(name, href, notClose, ref) {
        let _this = this;
        let oldIndex = _this.checks.length;
        let newItem = {
            href: href,
            $tag: $('<li>').html(name + (notClose ? '' : '<span title="关闭" class="fa fa-close"' +
                ' data-type="close"></span>')).css({maxWidth: _this.maxWidth}).attr('title', name),
            $frame: $('<iframe>').attr('src', href),
            referer: ref
        }
        _this.checks.push(newItem);
        _this.$mainTags.append(newItem.$tag).css('width', (oldIndex + 1) * _this.maxWidth);
        _this.$mainContents.append(newItem.$frame);
        newItem.$frame[0].contentWindow.__href__ = ref;
        _this._check(oldIndex);
    },
    getIFrameIndex(name){
        for (let [index, item] of this.checks.entries()) {
            if(name.includes(item.href)){
                return index;
            }
        }
    },

    getRefererWindow(href) {
        let referer = null;
        this.checks.some((item) => {
                                                            let contentWindow = item.$frame[0].contentWindow;
            if (contentWindow.location.href.indexOf(href) > -1) {
                referer = contentWindow;
                return true;
            }
        });
                                if (typeof referer === 'object') {
            return referer;
        }
                                                                return null;
    },

    _close(index) {
        let _this = this;
        let checkItem = _this.checks[index];

        if(checkItem.href.includes('phone') && checkItem.href.includes('boxId')){
            console.log('---------');
            let boxList = checkItem.href.split('?')[1].split('&');
            let boxId = boxList[1];
            let open = localStorage.getItem(boxId);
            if(open == '1'){
                //util.error('请选择业务类型后关闭弹窗！');
                //return;
            }

        }

        checkItem.$tag.remove();
        checkItem.$frame.remove();
        _this.checks.splice(index, 1);

        if (_this.checkIndex > index) {
            _this.checkIndex--;
        } else if (_this.checkIndex === index) {
            let showIndex = _this.checks[index] ? index : (_this.checks[index - 1] ? index - 1 : -1);
            _this.checkIndex = -1;
            if (showIndex !== -1) {
                _this._check(showIndex);
            }
        }

        _this.$mainTags.css('width', _this.checks.length * 120);
    },

    closeByIndex(index) {
        this._close(index);
    },

    close() {
        this._close(this.checkIndex);
    }
}
